<template>
  <div class="itinerary-preview-banner">
    <div class="gap-2">
      <i class="icon icon-view-1"></i>
      <span>Preview mode: This is what your travellers will see when they book.</span>
    </div>
    <Button color="red" type="button" @click="previewBookingPage" :full="mobile" no-padding>
      <a :href="launchPreviewUrl" @click.prevent>Continue to launch <i class="icon icon-arrow-right-1"></i></a>
    </Button>
  </div>
</template>

<script setup>
import Button from 'app/javascript/src/components/Theme2/Button.vue'
import { useRouter } from 'vue-router'
import { useResponsive } from '@/helpers/vueHelpers.js'

const router = useRouter()
const { mobile } = useResponsive()

const launchPreviewUrl = router.currentRoute.value.path.replace('/preview', '/launch-preview')

const previewBookingPage = () => {
  router.push(launchPreviewUrl)
}
</script>

<style lang="scss" scoped>
.itinerary-preview-banner {
  background-color: $white;
  border-top: 1px solid $gray-lighter;
  padding: $spacing-6 $spacing-16;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @include mobile {
    flex-direction: column;
    gap: $spacing-4;
    padding: $spacing-4;
  }

  .gap-2 {
    display: flex;
    align-items: center;
    gap: $spacing-2;
    font-weight: $font-medium;

    .icon {
      background-color: $grey-50;
      padding: $spacing-2;
      height: 32px;
      width: 32px;
      border-radius: $rounded-2xl;
    }
  }
}
</style>
